import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Badge } from 'react-bootstrap';
import { countApproveWaitingRequests } from 'actions/requests';

class ApproveCount extends Component {
  constructor(props) {
    super(props);
    this.state = { approveCount: 0 };
  }

  componentDidMount() {
    this.setApproveCount();
  }

  componentWillReceiveProps(nextProps) {
    const { badges } = this.props;
    const approveCount = nextProps.badges.approveCount;

    if (
      approveCount === null ||
      (badges && approveCount !== badges.approveCount)
    ) {
      this.setApproveCount();
    }
  }

  setApproveCount = () => {
    this.props.countApproveWaitingRequests().then(res => {
      this.setState({ approveCount: res.payload.data.data.length });
    });
  };

  render() {
    const { approveCount } = this.state;
    if (!approveCount) return null;
    return <Badge style={{ marginLeft: 10 }}>{approveCount}</Badge>;
  }
}

function mapStateToProps({ badges }) {
  return { badges };
}

export default connect(
  mapStateToProps,
  { countApproveWaitingRequests }
)(ApproveCount);



// WEBPACK FOOTER //
// ./src/components/MainMenu/Badges/ApproveCount.js